import { DateTime } from 'luxon';

import { PaymentFrequency } from '@willow/types-iso';

/**
 * Start of the first billing period Willow collects: one payment period before the first collected
 * payment, on the same day of the month, matching the fixed-rate and ARM calculators' interest period start.
 */
export const getStartOfFirstCollectedBillingPeriod = (
  firstCollectedPaymentDate: Date,
  paymentFrequency: PaymentFrequency,
): Date =>
  DateTime.fromJSDate(firstCollectedPaymentDate)
    .minus({ months: 12 / paymentFrequency })
    .startOf('day')
    .toJSDate();
